module.exports = __webpack_public_path__ + "static/media/Search.d57d2484.png";